import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../../../../../Common';

import './index.scss';

const MutatePionUrlContent = ({ name, ...props }) => {
  const [field, { error }] = useField(name);

  return (
    <Input
      {...props}
      {...field}
      className={classNames(
        'mutate-pion-url-content',
        { 'mutate-pion-url-content-error': error },
        props.className,
      )}
      type="url"
      placeholder="URL"
    />
  );
};

export default MutatePionUrlContent;
